import { axios } from '@Root/API'

export const create = payload => {
  return axios.post('admin/notification/update-user-template', payload)
}
